import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsPicClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/pic');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic ');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/pic', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic ');
    }
  }

  async findByUsuario(queries = {}) {
    try {
      return await this.api.get('/pic/findPicByUsuario?page=1&perPage=5&sortBy=created_at&sortDesc=true');
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic ');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/pic', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Pic ');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/pic/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pic ');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/pic/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pic ');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/pic/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Pic ');
    }
  }

  async getPicFindBySituacao(queries) {
    try {
      if (!queries) throw this.error.message(null, '[ getPicFindBySituacao ] Parâmetros inválidos');
      const { data: response } = await this.api.get('/pic/findPicBySituacao', { params: queries });
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic ');
    }
  }
}
